import { FormattedMessage } from 'react-intl';
import styles from './Metadata.module.scss';
import { Cell } from '_common/components/Table';

const NotApplicable = ({ place }: { place: 'table' | 'details' }) => {
  if (place === 'table') {
    return <Cell.Empty>NA</Cell.Empty>;
  }

  return (
    <div className={styles.notApplicable}>
      <FormattedMessage id="NOT_APPLICABLE" />
    </div>
  );
};

export default NotApplicable;
